export default __webpack_public_path__ + "static/media/targetOn.7f743c61.png";